module.exports = __webpack_public_path__ + "img/44.95d4fe0f.jpg";